jQuery(document).ready(function () {

    jQuery('.wpcf7-form').each(function () {
        // Is Repeater Use in form
        var repeater_count = jQuery(this).find('.uacf7-repeater-count').val();

        var uacf7_sid = 1;
        var form_id = jQuery(this).find("input[name=_wpcf7]").val();
        var uacf7_next = jQuery(this).find('.uacf7-next[data-form-id="' + form_id + '"]');
        var uacf7_prev = jQuery(this).find('.uacf7-prev[data-form-id="' + form_id + '"]');
        var uacf7_step = '.uacf7-step-' + form_id;
        var total_steps = jQuery(uacf7_step, this).length;

        jQuery(uacf7_step, this).each(function () {
            var $this = jQuery(this);
            $this.attr('id', form_id + 'step-' + uacf7_sid);
            $this.attr('step-id', uacf7_sid);

            if (uacf7_sid == 1) {
                $this.addClass('step-start');
            }

            if (total_steps == uacf7_sid) {
                $this.addClass('step-end');
            }

            uacf7_sid++;

        });
        uacf7_prev.on('click', function (e) {
            e.preventDefault();
        });

        uacf7_next.on('click', function (e) {
            e.preventDefault();

            var $this = jQuery(this);
            uacf7_step_validation($this, uacf7_step, form_id, repeater_count);
        });
    });



    function uacf7_step_validation($this, uacf7_step, form_id, repeater_count) {
        var uacf7_current_step = jQuery($this).closest(uacf7_step);
        var uacf7_next_step = 1 + parseInt(uacf7_current_step.attr('step-id'));

        /*
        * Cheeck current step fields. Expect Checkbox, Radio button and hidden fields
        */
        var uacf7_current_step_fields = uacf7_current_step.find('.wpcf7-form-control:not(.uacf7-hidden .wpcf7-form-control, span.wpcf7-form-control)').map(function () {
            if (typeof this.name !== 'undefined') {
                var nameIndex = this.name.indexOf('[]');
                if (nameIndex !== -1) {
                    var fieldName = this.name.replace('[]', '');
                } else {
                    var fieldName = this.name;
                }
                return fieldName;
            }
        }).get();

        /*
        * Cheeck current step fields. Only Checkbox and Radio button
        */
        if (uacf7_current_step.find('.wpcf7-form-control input').length > 0) {
            uacf7_current_step.find('.wpcf7-form-control input').each(function () {

                var Value = jQuery('.wpcf7-form-control input[name="' + this.name + '"]:checked').val();

                if (jQuery(this).is("input[type='checkbox']")) {
                    if (typeof Value == 'undefined') {
                        var checkboxName = this.name.replace('[]', '');
                        uacf7_current_step_fields.push(checkboxName);
                    }

                } else {
                    if (typeof Value == 'undefined') {
                        var checkboxName = this.name;
                        uacf7_current_step_fields.push(checkboxName);
                    }
                }
            });
        }

        function uacf7_onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        }

        //Current step fields
        var uacf7_current_step_fields = uacf7_current_step_fields.filter(uacf7_onlyUnique);

        var uacf7_form_ids = '';

        var fields_to_check_serialized = jQuery(uacf7_current_step).find(".wpcf7-form-control").serialize();

        if (jQuery(uacf7_current_step).find(".wpcf7-form-control[type='file']").length > 0) {
            jQuery(uacf7_current_step).find(".wpcf7-form-control[type='file']").each(function (i, n) {
                fields_to_check_serialized += "&" + jQuery(this).attr('name') + "=" + jQuery(this).val();
                if (jQuery(this)[0].files.length > 0) {
                    var file_size = jQuery(this)[0].files[0].size;
                    fields_to_check_serialized += "&" + jQuery(this).attr('name') + "_size=" + file_size;
                }
            });
        }
        // console.log( console.log(fields_to_check_serialized))

        var validation_fields = [];
        for (let i = 0; i < uacf7_current_step_fields.length; i++) {
            if (uacf7_current_step_fields[i] != '') {
                var type = jQuery("[name=" + uacf7_current_step_fields[i] + "]");
                if (typeof type[0] === 'undefined') {
                    type = jQuery('[name="' + uacf7_current_step_fields[i] + '[]"]');
                }
                type = type[0].localName;
                // Repeater Validation issue 
                if (typeof repeater_count != 'undefined') {
                    var value = jQuery("[name=" + uacf7_current_step_fields[i] + "]").val();
                    var valuecheckbox = jQuery("[name=" + uacf7_current_step_fields[i] + "][type='checkbox']");
                    if (value == '' || valuecheckbox.length > 0) {
                        validation_fields.push('' + type + ':' + uacf7_current_step_fields[i] + '');
                    }
                } else {
                    validation_fields.push('' + type + ':' + uacf7_current_step_fields[i] + '');
                }
            }

        }


  const formId = jQuery('.uacf7-step').filter(':visible').attr('step-id');
  const $currentStep = jQuery('#22972step-' + formId);
  
  // 清除错误
  $currentStep.find('.wpcf7-not-valid-tip').remove();
  $currentStep.find('.wpcf7-not-valid').removeClass('wpcf7-not-valid');
  
  let hasError = false;
  
  // 只验证必填字段
  $currentStep.find('[required]').each(function() {
    const $field = jQuery(this);
    
    if (!$field.val() || $field.val().trim() === '') {
      hasError = true;
      
      const $wrap = $field.closest('.wpcf7-form-control-wrap');
      $field.addClass('wpcf7-not-valid').attr('aria-invalid', 'true');
      
      if ($wrap.length) {
        $wrap.append('<span class="wpcf7-not-valid-tip">Please fill out this field.</span>');
      } else {
        $field.after('<span class="wpcf7-not-valid-tip">Please fill out this field.</span>');
      }
    }
  });
  
  if (hasError) return false;



        // 移除整个 jQuery.ajax 调用，直接执行成功逻辑
        jQuery($this).closest(".uacf7-step").find('.uacf7-ajax-loader').addClass('is-active');

        // 短暂延迟模拟加载效果（可选）
        setTimeout(function() {
            jQuery($this).closest(".uacf7-step").find('.uacf7-ajax-loader').removeClass('is-active');
            
            var $form = jQuery('form');
            clear_error_messages($form, uacf7_current_step); // 如果有这个函数就保留
            
            // 直接执行成功逻辑
            var curStep = jQuery($this).closest(".uacf7-step"),
                curStepBtn = curStep.attr("id"),
                nextStepWizard = jQuery('div.setup-panel div a[href="#' + curStepBtn + '"]').parent().next().children("a");

            jQuery('.steps-step').find('a[data-form-id="' + form_id + '"]').removeClass('uacf7-btn-active');
            uacf7_current_step.hide();
            uacf7_current_step.addClass('completed');
            jQuery('#' + form_id + 'step-' + uacf7_next_step).show();

            jQuery('.steps-step').find('a[href="#' + curStepBtn + '"]').addClass('completed');
            jQuery('.steps-step').find('a[href="#' + form_id + 'step-' + uacf7_next_step + '"]').addClass('uacf7-btn-active');
            jQuery('.steps-step').find('a[href="#' + form_id + 'step-' + uacf7_next_step + '"]').parent().addClass('step-complete');

            // 隐藏所有步骤标题
            jQuery('.current-step-title').find('.step-title').hide();
            // 显示下一步标题
            jQuery('.current-step-title').find('.step-title.step-' + uacf7_next_step).show();

            // 滚动到顶部（如果需要）
            //if (typeof uacf7_multistep_scroll !== 'undefined' && uacf7_multistep_scroll.scroll_top == 1) {
                multistep_scroll_to_top($this.parents('form'));
            //}
        }, 300); // 300毫秒延迟，可以改成0立即执行


    }

    function clear_error_messages($form, uacf7_current_step) {
        $form.removeClass('invalid');
        jQuery('.wpcf7-response-output', $form).removeClass('wpcf7-validation-errors');
        jQuery('.wpcf7-form-control', uacf7_current_step).removeClass('wpcf7-not-valid');
        jQuery('[aria-invalid]', uacf7_current_step).attr('aria-invalid', 'false');
        jQuery('.wpcf7-not-valid-tip', uacf7_current_step).remove();
    }

    function multistep_scroll_to_top(element) {
        jQuery([document.documentElement, document.body]).animate({
            scrollTop: jQuery(element).offset().top - 150
        }, 500);
    }

    function acceptance_validation($this, uacf7_next, uacf7_step) {
        var $this = $this.closest(uacf7_step);
        var acceptance = $this.find('.wpcf7-acceptance');
        if (acceptance.length == 0) {
            return false;
        }
        acceptance.each(function () {
            if (jQuery(this).hasClass('invert')) {
                var invert = true;
            } else {
                var invert = false;
            }
            if (jQuery(this).hasClass('optional')) {
                var optional = true;
            } else {
                var optional = false;
            }
            acceptance_validation_disabled_button($this, invert, optional, uacf7_next, this.checked);

            jQuery(this).find('input[type="checkbox"]').change(function () {
                acceptance_validation_disabled_button($this, invert, optional, uacf7_next, this.checked);
            });


        });
    }
    function acceptance_validation_disabled_button($this, invert, optional, uacf7_next, checked) {
        if (invert == true && checked == false) {
            var next_disable = false
        } else if (invert == false && checked == true) {
            var next_disable = false
        } else {
            var next_disable = true
        }
        if (next_disable == true) {
            $this.find(uacf7_next).prop("disabled", true)
        } else {
            $this.find(uacf7_next).prop("disabled", false)
        }
        if (optional == true) {
            $this.find(uacf7_next).prop("disabled", false)
        }
    }

});